import * as pdfjsLib from 'pdfjs-dist';

pdfjsLib.GlobalWorkerOptions.workerSrc =
  '//cdn.jsdelivr.net/npm/pdfjs-dist@2.6.347/build/pdf.worker.js';

export function loadPdf(url: string) {
  // CVE-2024-4367: disable generated JavaScript while the PDF.js major-version
  // migration is pending. Both image and CAD uploads must use this boundary.
  return pdfjsLib.getDocument({ url, isEvalSupported: false });
}
